import { createSlice } from '@reduxjs/toolkit';
import {
  fetchGroupMaterial,
  fetchMaterialsByGroup,
} from '../actions/material.action';

const initialState = {
  listMaterials: {
    data: {},
    total: 0,
    offset: 0,
    limit: 20,
    isLoading: false,
    isNeedReloadData: false,
  },
  groupMaterials: {
    data: {},
    isLoading: false,
    isNeedReloadData: false,
  },
};

export const materialReducer = createSlice({
  name: 'MaterialReducer',
  initialState,
  reducers: {
    needReloadStoneSurface(state) {
      state.listMaterials.isNeedReloadData = true;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMaterialsByGroup.pending, (state, action) => {
        state.listMaterials = {
          ...state.listMaterials,
          isLoading: action.meta.arg?.materialGroup,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchMaterialsByGroup.fulfilled, (state, action) => {
        if (action.payload) {
          const { data: newData, total, offset } = action.payload;
          const { materialGroup } = action.meta.arg;
          const { limit, data: oldData } = state.listMaterials;
          if (offset) {
            if (newData)
              state.listMaterials = {
                ...state.listMaterials,
                data: { ...oldData, [materialGroup]: [...newData] },
                total,
                offset: offset ?? 0 + limit,
                isLoading: false,
              };
          } else {
            state.listMaterials = {
              ...state.listMaterials,
              data: { ...oldData, [materialGroup]: [...(newData ?? [])] },
              total,
              offset: offset ?? 0 + limit,
              isLoading: false,
            };
          }
        }
      })
      .addCase(fetchGroupMaterial.pending, state => {
        state.groupMaterials = {
          ...state.groupMaterials,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchGroupMaterial.fulfilled, (state, action) => {
        if (action.payload) {
          const { data: newData } = action.payload;
          const { materialType, supplier } = action.meta.arg;
          state.groupMaterials = {
            ...state.groupMaterials,
            data: {
              ...state.groupMaterials.data,
              [`${materialType}-${supplier}`]: [...newData],
            },
          };
        }
      });
  },
});

export const { needReloadStoneSurface } = materialReducer.actions;

export default materialReducer.reducer;
